<script>
import { Bar } from 'vue-chartjs'
import _map from 'lodash/map'
import _values from 'lodash/values'
import _mapValues from 'lodash/mapValues'
import _get from 'lodash/get'
import _mean from 'lodash/mean'

export default {
  name: 'BarChart',
  extends: Bar,
  props: {
    data: {
      type: Array,
      required: true,
    },
    datasets: {
      type: Object,
      required: true,
    },
    dataKey: {
      type: String,
      default: 'id',
    },
    defaultDataKeyValue: {
      type: String,
      default: '',
    },
    average: {
      type: String,
      default: '',
    },
    stepSize: {
      type: Number,
      default: 1,
    },
    suggestedMax: {
      type: Number,
      default: 10,
    },
  },
  computed: {
    chartdata () {
      const chartdata = {
        labels: this.data.map(item => item[this.dataKey] || this.defaultDataKeyValue),
        datasets: _values(_mapValues(this.datasets, (settings, key) => ({
          ...settings,
          data: _map(this.data, item => _get(item, key)),
        }))),
      }

      return this.average
        ? this.appendAverage(chartdata)
        : chartdata
    },
    options () {
      return {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: this.stepSize,
              offset: true,
              suggestedMax: this.suggestedMax,
            },
          }],
        },
        legend: { position: 'bottom' },
        responsive: true,
        maintainAspectRatio: false,
      }
    },
  },
  watch: {
    chartdata () {
      this.renderChart(this.chartdata, this.options)
    },
  },
  mounted () {
    this.renderChart(this.chartdata, this.options)
  },
  methods: {
    appendAverage ({ labels, datasets }) {
      return {
        labels: [this.average, ...labels],
        datasets: datasets.map(({ data, ...rest }) => ({
          data: [Math.round(_mean(data) * 10) / 10, ...data],
          ...rest,
        })),
      }
    },
  },
}
</script>
